import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Service from "../Services/Service";
import common from "../Scripts/Common";
import loaderGif from "../Images/loader.gif";
import "../styles/category.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Box,
  Modal,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

let vVndrUserID = 0;
let arrSlctdInvitation = [];

const Invitation = () => {
  const [loading, setLoading] = useState(false);
  const ddlCategoryID = useRef(null);
  const txtVendor = useRef(null);
  const txtContact = useRef(null);
  const txtEmail = useRef(null);
  const [invitation, setInvitation] = useState([]);
  const [options, setOptions] = useState([]);
  const [editing, setEditing] = useState(false);

  const [open, setOpen] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Invitation");
    //Service.setApiUrl("https://localhost:7106/api/Invitation");
    fetchInvitation();
    bindCategory();
  }, []);

  const navigate = useNavigate();

  // const fetchInvitation = async () => {
  //   const res = await Service.getAll();
  //   setInvitation(res.data);
  // };

  const fetchInvitation = async () => {
    try {
      const res = await Service.getAll();

      console.log("API Response:", res);
      console.log("API Data:", res.data);
      console.table(res.data);

      setInvitation(res.data);
    } catch (err) {
      console.error("Error fetching invitations:", err);
    }
  };
  const bindCategory = async () => {
    const res = await Service.loadCategory(0, "Category");
    setOptions(res.data);
  };

  const emailBlur = (e) => {
    const value = e.target.value;
    if (value !== "") {
      if (!common.validateEmail(value)) {
        e.target.value = "";
        alert("Invalid email format!");
        e.target.focus();
      } else {
        handleDuplicate(e);
      }
    }
  };

  // ✅ safe clear
  const clear = () => {
    vVndrUserID = 0;
    ddlCategoryID.current && (ddlCategoryID.current.value = "");
    txtVendor.current && (txtVendor.current.value = "");
    txtContact.current && (txtContact.current.value = "");
    txtEmail.current && (txtEmail.current.value = "");
    arrSlctdInvitation = [];
    setEditing(false);
  };

  const handleDuplicate = async (e) => {
    let vColumnName, vError;
    const controlName = e.target.name;
    if (controlName === "vendorName") {
      if (vVndrUserID > 0 && e.target.value === arrSlctdInvitation.vendorName)
        return;
      vColumnName = "Vendor";
      vError = "Duplicate Vendor!";
    } else if (controlName === "contactNo") {
      if (vVndrUserID > 0 && e.target.value === arrSlctdInvitation.contactNo)
        return;
      vColumnName = "Contact";
      vError = "Duplicate Contact No.!";
    } else if (controlName === "emailID") {
      if (vVndrUserID > 0 && e.target.value === arrSlctdInvitation.emailID)
        return;
      vColumnName = "Email";
      vError = "Duplicate Email Id.!";
    }

    const found = invitation.some(
      (inv) =>
        (vColumnName === "Vendor" &&
          inv.vendorName.toLowerCase() === e.target.value.toLowerCase()) ||
        (vColumnName === "Contact" &&
          inv.contactNo.toLowerCase() === e.target.value.toLowerCase()) ||
        (vColumnName === "Email" &&
          inv.emailID.toLowerCase() === e.target.value.toLowerCase()),
    );

    if (found) {
      alert(vError);
      e.target.value = "";
      e.target.focus();
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const vendorName = txtVendor.current?.value?.trim() || "";
  //   const contactNo = txtContact.current?.value?.trim() || "";

  //   // Vendor Name validation
  //   if (!vendorName) {
  //     setSnackbar({
  //       open: true,
  //       message: "Vendor Name is required!",
  //       severity: "error",
  //     });
  //     return;
  //   }

  //   // Vendor Name format validation
  //   const vendorNameRegex = /^[A-Za-z]+(?:[ .'-][A-Za-z]+)*$/;

  //   if (!vendorNameRegex.test(vendorName)) {
  //     setSnackbar({
  //       open: true,
  //       message: "Please enter a valid Vendor Name",
  //       severity: "error",
  //     });
  //     return;
  //   }

  //   // Contact Number validation
  //   if (!/^\d{10}$/.test(contactNo)) {
  //     setSnackbar({
  //       open: true,
  //       message: "Contact Number must be exactly 10 digits!",
  //       severity: "error",
  //     });
  //     return;
  //   }

  //   let strMsg =
  //     vVndrUserID === 0
  //       ? "Vendor added successfully"
  //       : "Vendor updated successfully";
  //   setLoading(true);
  //   try {
  //     await Service.create({
  //       VndrUserID: vVndrUserID,
  //       CategoryID: ddlCategoryID.current?.value || "",
  //       VendorName: vendorName,
  //       ContactNo: txtContact.current?.value || "",
  //       EmailID: txtEmail.current?.value || "",
  //       OpFlag: editing ? "Update" : "Insert",
  //       UserName: sessionStorage.getItem("userEmail") || "",
  //     });
  //     clear();
  //     fetchInvitation();
  //     alert(strMsg);
  //     setOpen(false);
  //   } catch (error) {
  //     //console.error('Error saving category:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const categoryID = ddlCategoryID.current?.value?.trim() || "";
    const vendorName = txtVendor.current?.value?.trim() || "";
    const contactNo = txtContact.current?.value?.trim() || "";
    const emailID = txtEmail.current?.value?.trim() || "";

    let newErrors = {};

    // =========================
    // MANDATORY VALIDATION
    // =========================

    if (!categoryID) {
      newErrors.categoryID = "Category Name is required";
    }

    if (!vendorName) {
      newErrors.vendorName = "Vendor Name is required";
    }

    if (!contactNo) {
      newErrors.contactNo = "Contact No. is required";
    }

    if (!emailID) {
      newErrors.emailID = "Email ID is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // =========================
    // VENDOR NAME VALIDATION
    // =========================

    const vendorNameRegex = /^[A-Za-z]+(?:[ .'-][A-Za-z]+)*$/;

    if (!vendorNameRegex.test(vendorName)) {
      newErrors.vendorName = "Please enter a valid Vendor Name";
    }

    // =========================
    // CONTACT VALIDATION
    // =========================

    if (!/^\d{10}$/.test(contactNo)) {
      newErrors.contactNo = "Contact Number must be exactly 10 digits";
    }

    // =========================
    // EMAIL VALIDATION
    // =========================

    if (!common.validateEmail(emailID)) {
      newErrors.emailID = "Invalid email format";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // =========================
    // DUPLICATE VALIDATION
    // =========================

    const duplicateVendor = invitation.some(
      (inv) =>
        inv.vendorName?.trim().toLowerCase() === vendorName.toLowerCase() &&
        !(vVndrUserID > 0 && inv.vndrUserID === vVndrUserID),
    );

    if (duplicateVendor) {
      newErrors.vendorName = "Duplicate Vendor!";
    }

    const duplicateContact = invitation.some(
      (inv) =>
        inv.contactNo?.trim() === contactNo &&
        !(vVndrUserID > 0 && inv.vndrUserID === vVndrUserID),
    );

    if (duplicateContact) {
      newErrors.contactNo = "Duplicate Contact No.!";
    }

    const duplicateEmail = invitation.some(
      (inv) =>
        inv.emailID?.trim().toLowerCase() === emailID.toLowerCase() &&
        !(vVndrUserID > 0 && inv.vndrUserID === vVndrUserID),
    );

    if (duplicateEmail) {
      newErrors.emailID = "Duplicate Email Id.!";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Clear validation errors
    setErrors({});

    // =========================
    // YOUR ORIGINAL SAVE CODE
    // =========================

    let strMsg =
      vVndrUserID === 0
        ? "Vendor added successfully"
        : "Vendor updated successfully";

    setLoading(true);

    try {
      await Service.create({
        VndrUserID: vVndrUserID,
        CategoryID: ddlCategoryID.current?.value || "",
        VendorName: vendorName,
        ContactNo: txtContact.current?.value || "",
        EmailID: txtEmail.current?.value || "",
        OpFlag: editing ? "Update" : "Insert",
        UserName: sessionStorage.getItem("userEmail") || "",
      });

      clear();
      fetchInvitation();
      alert(strMsg);
      setOpen(false);
    } catch (error) {
      console.error("Error saving invitation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (invit) => {
    arrSlctdInvitation = invit;
    if (invit.vndrStatus === "Invited") {
      vVndrUserID = invit.vndrUserID;
      setOpen(true);
      setTimeout(() => {
        if (ddlCategoryID.current)
          ddlCategoryID.current.value = invit.categoryID;
        if (txtVendor.current) txtVendor.current.value = invit.vendorName;
        if (txtContact.current) txtContact.current.value = invit.contactNo;
        if (txtEmail.current) txtEmail.current.value = invit.emailID;
        setEditing(true);
      }, 0);
    } else {
      alert(
        "The selected vendor is already in a " + invit.vndrStatus + " status!",
      );
    }
  };

  // ✅ open first, clear after refs mount
  const handleAddClick = () => {
    setOpen(true);
    setTimeout(() => clear(), 0);
  };

  const handleDelete = async (vndrUserID, opFlag) => {
    if (window.confirm("Are you sure to delete this invitation?")) {
      await Service.remove(vndrUserID, opFlag);
      fetchInvitation();
    }
  };

  // DataGrid columns
  const columns = [
    {
      field: "categoryName",
      headerName: "Category Name",
      flex: 1,
      minWidth: 120,
      sortable: true,
    },
    {
      field: "vendorName",
      headerName: "Vendor Name",
      flex: 1,
      minWidth: 120,
      sortable: true,
      renderCell: (params) => params.value?.toString().trim() || "N/A",
    },
    {
      field: "contactNo",
      headerName: "Contact No",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => params.value?.toString().trim() || "N/A",
    },
    { field: "emailID", headerName: "Email ID", flex: 1, minWidth: 150 },
    { field: "vndrStatus", headerName: "Status", flex: 1, minWidth: 100 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 150, // ensures buttons are always visible
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "3px",
            height: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="success"
            size="small"
            onClick={() => handleEdit(params.row)}
            sx={{ mr: 1 }}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleDelete(params.row.vndrUserID, "Delete")}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        paddingLeft: 50,
        paddingRight: 50,
      }}
    >
      <Box
        sx={{
          width: "100%",
          border: "1px solid rgba(0,0,0,0.12)",
          borderRadius: 2,
          boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
          p: 2,
        }}
      >
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
          <Button variant="contained" onClick={handleAddClick}>
            Add Invitation
          </Button>
        </Box> */}

        <Box display="flex" justifyContent="space-between" mb={2}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/DashboardFinal")}
          >
            Back to Home
          </Button>
          <Button variant="contained" onClick={handleAddClick}>
            Add Invitation
          </Button>
        </Box>

        <Box sx={{ flex: 1 }}>
          {" "}
          {/* allows DataGrid to fill remaining height */}
          {/* <DataGrid
            rows={invitation}
            columns={columns}
            getRowId={(row) => row.vndrUserID}
            pageSizeOptions={[5, 10, 20]}
            paginationModel={{ pageSize: 5, page: 0 }}
            onPaginationModelChange={(model) => { }}
            sx={{
              border: 'none',
              height: '100%', // fill parent Box height
            }}
          /> */}
          {/* <DataGrid
  rows={invitation}
  columns={columns}
  getRowId={(row) => row.vndrUserID}
  pageSizeOptions={[5,10,20]}
  paginationModel={paginationModel}
  onPaginationModelChange={setPaginationModel}
/> */}
          {/* <DataGrid
            rows={invitation}
            columns={columns}
            autoHeight
            getRowId={(row) => row.vndrUserID}
            pageSizeOptions={[5, 10, 20]}
            paginationModel={paginationModel}
            onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
            sx={{
              border: "none",
              height: "100%",
            }}
          /> */}
          <DataGrid
            rows={invitation}
            columns={columns}
            getRowId={(row) => row.vndrUserID}
            autoHeight
            pageSizeOptions={[25, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                  page: 0,
                },
              },
            }}
          />{" "}
        </Box>

        {/* Modal */}
        <Modal open={open} onClose={() => setOpen(false)}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              p: 3,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              maxWidth: 400,
              mx: "auto",
              mt: "10%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* <FormControl fullWidth>
              <InputLabel shrink>Category Name</InputLabel>
              <Select
                native
                name="categoryID"
                inputRef={ddlCategoryID}
                defaultValue=""
                required
              >
                <option value="">-- Select an option --</option>
                {options.map((option) => (
                  <option key={option.categoryID} value={option.categoryID}>
                    {option.categoryName}
                  </option>
                ))}
              </Select>
            </FormControl> */}

            <FormControl fullWidth error={!!errors.categoryID}>
              <InputLabel shrink>Category Name *</InputLabel>

              <Select
                native
                name="categoryID"
                inputRef={ddlCategoryID}
                defaultValue=""
              >
                <option value="">-- Select an option --</option>

                {options.map((option) => (
                  <option key={option.categoryID} value={option.categoryID}>
                    {option.categoryName}
                  </option>
                ))}
              </Select>

              {errors.categoryID && (
                <div
                  style={{
                    color: "#d32f2f",
                    fontSize: "12px",
                    marginTop: "4px",
                    marginLeft: "14px",
                  }}
                >
                  {errors.categoryID}
                </div>
              )}
            </FormControl>

            {/* <TextField
              label="Vendor Name"
              name="vendorName"
              inputRef={txtVendor}
              required
              onBlur={handleDuplicate}
            /> */}

            <TextField
              label="Vendor Name *"
              name="vendorName"
              inputRef={txtVendor}
              error={!!errors.vendorName}
              helperText={errors.vendorName || ""}
            />
            {/* <TextField
              label="Contact No."
              name="contactNo"
              inputRef={txtContact}
              required
              inputProps={{ maxLength: 10 }}
              onChange={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
              }}
              onBlur={handleDuplicate}
            /> */}

            <TextField
              label="Contact No. *"
              name="contactNo"
              inputRef={txtContact}
              error={!!errors.contactNo}
              helperText={errors.contactNo || ""}
              inputProps={{ maxLength: 10 }}
              onChange={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
              }}
            />
            {/* <TextField
              label="Email ID"
              name="emailID"
              inputRef={txtEmail}
              required
              onBlur={emailBlur}
            /> */}

            <TextField
              label="Email ID *"
              name="emailID"
              inputRef={txtEmail}
              error={!!errors.emailID}
              helperText={errors.emailID || ""}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="submit" variant="contained">
                {editing ? "Update" : "Add"}
              </Button>
            </Box>

            {loading && (
              <Box sx={{ textAlign: "center" }}>
                <img src={loaderGif} alt="Loading..." style={{ width: 50 }} />
              </Box>
            )}
          </Box>
        </Modal>
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default Invitation;
